// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import Vuex from 'vuex'
Vue.use(Vuex)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import '@/assets/fonticon/iconfont.css'
import '@/assets/css/public.css'
import '@/assets/css/mobile.css'

//Vue.config.productionTip = false

import * as filters from '@/filters/index'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import jquery from 'jquery'
Vue.prototype.$ = jquery

import Global from './utils/Global';
Vue.prototype.$global = Global;

import Meta from 'vue-meta'
Vue.use(Meta)

import {
  handleTree, 
  phoneCheck, 
  getStudyYears, 
  isEmpty, 
  strToArray, 
  inArray, 
  delArray, 
  gotoUrl, 
  gotoUrlParams,
  getRandom, 
  getArrIndexs, 
  getTypeIndex, 
  getTypeName,
  isMobile,
  gotoMobile
} from "@/utils/function";
Vue.prototype.handleTree = handleTree
Vue.prototype.phoneCheck = phoneCheck
Vue.prototype.getStudyYears = getStudyYears
Vue.prototype.isEmpty = isEmpty
Vue.prototype.strToArray = strToArray
Vue.prototype.inArray = inArray
Vue.prototype.delArray = delArray
Vue.prototype.gotoUrl = gotoUrl
Vue.prototype.gotoUrlParams = gotoUrlParams
Vue.prototype.getRandom = getRandom
Vue.prototype.getArrIndexs = getArrIndexs
Vue.prototype.getTypeIndex = getTypeIndex
Vue.prototype.getTypeName = getTypeName
Vue.prototype.isMobile = isMobile
Vue.prototype.gotoMobile = gotoMobile

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js